/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Passkey_CreatedInputs */



/**
* | output |
* | --- |
* | "Passkey created successfully!" |
*
* @param {Profile_Security_Passkey_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_passkey_created = /** @type {((inputs?: Profile_Security_Passkey_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Passkey_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey erfolgreich erstellt!")
	return /** @type {LocalizedString} */ ("Passkey created successfully!")
});